// src/helpers/factories/registerMenuTypeDropdownFactory.ts
var menuTypeDropdownMap = (menuType) => ({
  id: menuType.menuTypeId,
  label: menuType.posName,
  value: menuType.menuTypeId
});
var registerMenuTypeDropdownFactory = (menuTypes) => {
  return Object.values(menuTypes).filter((menuType) => menuType.active).map(menuTypeDropdownMap);
};
var allRegisterMenuTypeDropdownFactory = (menuTypes) => {
  return Object.values(menuTypes).map(menuTypeDropdownMap);
};

export { allRegisterMenuTypeDropdownFactory, registerMenuTypeDropdownFactory };
